import { http } from '@/system/http';
import { computed, ref } from 'vue';

const attachedServiceRates = ref([]);
const deductibleCode = ref(null);
const loading = ref(false);
const error = ref(null);

export function useServiceRates() {
    function reloadServiceRatesFromBooking(bookingId) {
        loading.value = true;

        http.get('/app/helfo-service-rates/booking/' + bookingId + '/service-rates')
            .then(response => {

                attachedServiceRates.value = response.data.bookingRates;
                deductibleCode.value = response.data.deductibleCode;

                loading.value = false;
            })
            .catch(error => {
                error.value = error;
                loading.value = false;
            });
    }

    function increaseRate(bookingId, rate) {
        rate.quantity++;

        http.put('/app/helfo-service-rates/booking/' + bookingId + '/service-rate/' + rate.rate_resource_id + '/increase')
            .then(() => {

                toastr.success('Rate amount increased', 'Changes Saved', {timeOut: 2000});
            })
            .catch(error => {
                toastr.error('Failed to increase rate amount', 'Error', {timeOut: 2000});
            });
    }

    function decreaseRate(bookingId, rate) {
        if(rate.quantity !== 1) {
            rate.quantity--;

            http.put('/app/helfo-service-rates/booking/' + bookingId + '/service-rate/' + rate.rate_resource_id + '/decrease')
                .then(() => {
                    toastr.success('Rate amount decreased', 'Changes Saved', {timeOut: 2000});
                })
                .catch(error => {
                    toastr.error('Failed to decrease rate amount', 'Error', {timeOut: 2000});
                });
        }
        else {
            toastr.success('Cannot decrease rate below 1', 'Changes Saved', {timeOut: 2000});
        }
    }

    function removeRate(bookingId, rateToRemove) {
        http.delete('/app/helfo-service-rates/booking/' + bookingId + '/service-rate/' + rateToRemove.rate_resource_id + '/remove')
            .then(() => {
                attachedServiceRates.value = attachedServiceRates.value.filter((rate) =>
                    rate.rate_resource_id !== rateToRemove.rate_resource_id
                );
            })
            .catch(error => {
                console.error('Failed to remove rate', error);
            });
    }

    function calculateReimbursement() {
        let total = 0;

        if (Array.isArray(attachedServiceRates.value)) {
            attachedServiceRates.value.forEach(serviceRate => {
                if (typeof serviceRate.quantity === 'number' && serviceRate.refund !== null) {
                    total += serviceRate.quantity * parseFloat(serviceRate.refund);
                }
            });
        }

        return total
    }

    function calculateDeductible() {
        let totalDeductible = 0;

        if (Array.isArray(attachedServiceRates.value)) {
            attachedServiceRates.value.forEach(serviceRate => {
                if (typeof serviceRate.quantity === 'number' && serviceRate.deductible !== null) {
                    totalDeductible += serviceRate.quantity * parseFloat(serviceRate.deductible);
                }
            });
        }

        return totalDeductible;
    }

    const reimbursementTotal = computed(() => {
        if (deductibleCode.value !== null) {
            let total = calculateDeductible() + calculateReimbursement();
            return total.toFixed(2);
        }

        return calculateReimbursement().toFixed(2);
    });

    const deductibleTotal = computed(() => {
        if (deductibleCode.value !== null) {
            return 0.0;
        }

        return calculateDeductible().toFixed(2);
    });

    return {
        loading,
        error,
        attachedServiceRates,
        deductibleCode,
        reloadServiceRatesFromBooking,
        reimbursementTotal,
        deductibleTotal,
        increaseRate,
        decreaseRate,
        removeRate
    }
}
